module.exports = __webpack_public_path__ + "static/DontLoseMe-6d1bf4a8d7c7801efea682be209becba.jpg";